var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5C4 4.11929 5.11929 3 6.5 3H15.5C16.8807 3 18 4.11929 18 5.5V12.5C18 13.8807 16.8807 15 15.5 15H6.5C5.11929 15 4 13.8807 4 12.5V5.5ZM10.7465 9.93097L5 6.961V12.5C5 13.3284 5.67157 14 6.5 14H15.5C16.3284 14 17 13.3284 17 12.5V6.963L11.2535 9.93097L11.1725 9.96932C11.0334 10.0205 10.8769 10.0077 10.7465 9.93097ZM15.5 4H6.5C5.67157 4 5 4.67157 5 5.5V5.801L11 8.91991L17 5.802V5.5C17 4.67157 16.3284 4 15.5 4ZM13.5 17C14.3179 17 15.0441 16.6072 15.5002 16H6.5C4.567 16 3 14.433 3 12.5V5.5C2.39278 5.9561 2 6.68209 2 7.5V12.5C2 14.9853 4.01472 17 6.5 17H13.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailAll);
export default __webpack_public_path__ + "static/media/mail_all.738ac12e78a14fe555670b8038bf5082.svg";
export { ForwardRef as ReactComponent };